// extracted by mini-css-extract-plugin
export var icon = "bodyText-module--icon--refTh";
export var list = "bodyText-module--list--BxWd4";
export var show = "bodyText-module--show--FN5QQ";